<!-- 用于 小程序推广链接页 的 推广平台侧边栏 -->
<template>
<a-drawer
  title="推广平台"
  width="800px"
  placement="right"
  :closable="false"
  :visible="visible"
  @close="closeDrawer"
>
	<div class="form-cell-box">
		<div class="class-title">推广链接ID</div>
			
		<div style="font-size: 15px;">{{d_link_id}}</div>
	</div>
	
	<div class="form-cell-box">
		<div class="class-title">推广链接名称</div>
			
		<div style="font-size: 15px;">{{d_name}}</div>
	</div>
	
	<div class="form-cell-box">
		<div class="class-title">推广平台</div>
		<a-select
			style="width: 500px"
			placeholder="请选择"
			@change="handleChangeA"
			:filter-option="filterOption"
			:getPopupContainer="getsPopupContainer"
			:value="d_channel_id"
		  >
			<a-select-option value="1">巨量</a-select-option>
			<a-select-option value="5">腾讯</a-select-option>
			<a-select-option value="6">百度</a-select-option>
			<a-select-option value="7">快手</a-select-option>
			<a-select-option value="8">微博</a-select-option>
			<a-select-option value="2">OPPO</a-select-option>
			<a-select-option value="3">VIVO</a-select-option>
			<a-select-option value="4">华为</a-select-option>
		</a-select>
	</div>
	
	<div v-show="d_channel_id == '6'" style="padding: 20px;border: 1px solid #ccc;border-radius: 6px;margin-top: 30px;">
		<div style="font-weight: 600;margin-bottom: 15px;">推广账户参数（必填）</div>
		<div v-if="d_channel_id == '6'" class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">百度转化跟踪token</div>
			
			<a-textarea
				style="width: 450px;"
				  v-model="d_bd_token"
				  placeholder="请输入百度转化跟踪token"
				  :auto-size="{ minRows: 4, maxRows: 10 }"
			/>
		</div>
		
	</div>
	
	<div v-show="d_channel_id == '5'" style="padding: 20px;border: 1px solid #ccc;border-radius: 6px;margin-top: 30px;">
		<div style="font-weight: 600;margin-bottom: 15px;">推广链路设置（必填）</div>
		<div class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">推广链路</div>
			
			<a-select
				style="width: 550px"
				placeholder="请选择推广链路"
				@change="handleChangeC"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="d_put_type"
			  >
				<a-select-option :value="1">直投链路</a-select-option>
				<a-select-option :value="2">企微链路</a-select-option>
			</a-select>
		</div>
		
		<div v-if="d_put_type == 1" class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">回传方案</div>
			<div>
				<a-radio-group name="zt_radioGroup" :value="d_callback_type" @change="radioChangeD">
				    <a-radio :value="1">
						直投新版方案
				    </a-radio>
				</a-radio-group>
				<div v-if="d_callback_type == 1" style="font-size: 12px;margin-top: 6px;">新建转化（需加白名单），同时填写点击监测链接。openid匹配到广告计划。</div>
			</div>
			
		</div>
		<div v-if="d_put_type == 2" class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">回传方案</div>
			<div>
				<a-radio-group name="qw_radioGroup" :value="d_callback_type" @change="radioChangeD">
					<a-radio :value="2">
						企微旧版方案
					</a-radio>
					<a-radio :value="3">
						企微自研：点击监测IP匹配
					</a-radio>
				</a-radio-group>
				<div v-if="d_callback_type == 2" style="font-size: 12px;margin-top: 6px;">新建Web数据源ID，填写到飞碟。暂不支持匹配到广告计划。</div>
				<div v-else-if="d_callback_type == 3" style="font-size: 12px;margin-top: 6px;">点击监测IP匹配：仅适用于非微信广告位。新建转化（需加白名单），同时填写点击监测链接。IP匹配到广告计划。</div>
			</div>
		</div>
		
		<div v-show="d_callback_type == 2" class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">腾讯推广账户</div>
			
			<txAccSelect ref="getTxAccSelect" @select-handle="handleChangeB"></txAccSelect>
		</div>
		
		<div v-if="d_callback_type == 2" class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">Web数据源ID</div>
			
			<a-input v-model="d_user_action_set_id" allowClear placeholder="请输入" style="width: 550px;"/>
		</div>
	</div>
	
	<div v-if="d_channel_id == '5'" style="padding: 20px;border: 1px solid #ccc;border-radius: 6px;margin-top: 30px;">
		<div style="font-weight: 600;margin-bottom: 15px;">其他参数（必填，回传时给腾讯）</div>
		
		<div class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">书城</div>
			<a-input v-model="d_book_platform" allowClear placeholder="请输入" style="width: 550px;"/>
		</div>
		
		<div class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">回传作品名称</div>
			<a-input v-model="d_book_name" allowClear placeholder="请输入" style="width: 550px;"/>
		</div>
		
		<div class="screen-box" style="align-items: baseline;">
			<div class="screen-label" style="width: 120px;text-align: right;">回传作品URL</div>
			<a-input v-model="d_book_url" allowClear placeholder="请输入" style="width: 550px;"/>
		</div>
	</div>
	
	<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
		<a-button @click="drawerRequest" :loading="drawer_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
		<a-button @click="closeDrawer">取消</a-button>
	</div>
</a-drawer>
</template>

<script>
import { MPggSelectAcc, videoXcxEdit } from '@/request/api'
import txAccSelect from '@/components/selectCompont/txAccSelect.vue'
export default {
	name: 'tgptDrawer_',
	components: {
		txAccSelect
	},
	data() {
		return {
			visible: false,
			drawer_button_loading: false,
			
			d_link_id: null, // 推广链接ID
			d_name: "",
			d_channel_id: undefined, // 推广平台
			d_bd_token: null, // 百度转化跟踪token
			
			d_adv_id: undefined, // 腾讯推广账户
			d_user_action_set_id: null, // 数据源ID
			d_book_name: null, // 回传作品名称
			d_book_platform: null, // 书城
			d_book_url: null, // 回传作品URL
			
			d_put_type: undefined, // 推广链路
			d_callback_type: null, // 回传方案
			d_channel: undefined,
			
			txAccSelect: [], // 腾讯账号下拉
		}
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		getShowDrawer(e){
			let that = this
			
			that.d_link_id = e.link_id
			this.d_name = e.name
			this.d_channel = e.channel
			
			if(e.channel_id){
				this.d_channel_id = e.channel_id.toString()
			}
			else {
				this.d_channel_id = undefined
			}
			
			if(e.channel_id == 6 && e.token){ // 百度
				this.d_bd_token = e.token.toString() || ""
			}
			else if(e.channel_id == 5){ // 腾讯
				that.d_put_type = e.put_type
				that.d_callback_type = e.callback_type
				if(that.d_callback_type == 2){
					that.$nextTick(()=>{
						that.$refs.getTxAccSelect.getSelectData(e.adv_id)
					})
				}
				
				
				this.d_adv_id = e.adv_id // 腾讯推广账户
				this.d_user_action_set_id = e.user_action_set_id // 数据源ID
				this.d_book_name = e.book_name // 回传作品名称
				this.d_book_platform = e.book_platform // 书城
				this.d_book_url = e.book_url // 回传作品URL
			}
			
			this.visible = true
			
			// 要放在this.visible = true后面，因为要等节点出现
			// that.$nextTick(()=>{
			// 	that.$refs.getTxAccSelect.getSelectData(e.adv_id)
			// })
			
		},
		closeDrawer(){
			this.$refs.getTxAccSelect.closeValue()
			
			this.visible = false
			
			this.drawer_button_loading = false
			this.d_link_id = null
			this.d_name = ""
			
			this.d_channel_id = undefined, // 推广平台
			this.d_bd_token = null, // 百度转化跟踪token
			
			this.d_adv_id = undefined, // 腾讯推广账户
			this.d_user_action_set_id = null, // 数据源ID
			this.d_book_name = null, // 回传作品名称
			this.d_book_platform = null, // 书城
			this.d_book_url = null // 回传作品URL
			
		},
		handleChangeA(e){
			this.d_channel_id = e
		},
		handleChangeB(e){ // 腾讯推广账户
			this.d_adv_id = e
		},
		handleChangeC(e){
			let that = this
			this.d_put_type = e
			if(this.d_put_type == 1){ // 直投链路
				this.d_callback_type = 1
			}
			else { // 企微链路
				this.d_callback_type = 2
				that.$nextTick(()=>{
					that.$refs.getTxAccSelect.getSelectData(this.d_adv_id)
				})
			}
		},
		radioChangeD(e){
			let that = this
			this.d_callback_type = e.target.value
			if(this.d_callback_type == 2){
				that.$nextTick(()=>{
					that.$refs.getTxAccSelect.getSelectData(this.d_adv_id)
				})
			}
		},
		drawerRequest(){
			let that = this
			
			let r_data = {
				link_id: that.d_link_id, // 推广链接id
			}
			
			if(!that.d_channel_id){
				that.$message.warning('请先选择推广平台');
				return
			}
			
			r_data.channel = that.d_channel
			r_data.channel_id = that.d_channel_id // 推广平台id，1=巨量，2=oppo，3=vivo
			if(that.d_channel_id == 6){ // 百度
				if(!that.d_bd_token){
					that.$message.warning('请填写百度token');
					return
				}
				r_data.token = that.d_bd_token
			}
			else if(that.d_channel_id == 5){ // 腾讯
				if(!that.d_put_type){
					that.$message.warning('请先选择推广链路');
					return
				}
				else if(that.d_callback_type == 2 && !that.d_adv_id){
					that.$message.warning('请先选择推广账户');
					return
				}
				else if(that.d_callback_type == 2 && !that.d_user_action_set_id){
					that.$message.warning('请输入Web数据源ID');
					return
				}
				else if(!that.d_book_name){
					that.$message.warning('请输入书城');
					return
				}
				else if(!that.d_book_platform){
					that.$message.warning('请输入回传作品名称');
					return
				}
				else if(!that.d_book_url){
					that.$message.warning('请输入回传作品URL');
					return
				}
				
				r_data.put_type = that.d_put_type // 推广链路
				r_data.callback_type = that.d_callback_type // 回传方案
				
				r_data.adv_id = that.d_adv_id
				r_data.user_action_set_id = that.d_user_action_set_id
				r_data.book_name = that.d_book_name,
				r_data.book_platform = that.d_book_platform,
				r_data.book_url = that.d_book_url
			}
			that.drawer_button_loading = true
			videoXcxEdit(r_data).then(res=>{
				console.log("编辑渠道请求",res);
				that.drawer_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.closeDrawer()
					
					that.$message.success('操作成功');
					
					that.$emit('tgpt-request','')
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
	}
}
</script>

<style scoped>
.screen-box {
	margin-bottom: 15px;
}
</style>